import { render, staticRenderFns } from "./PaBusClsList.vue?vue&type=template&id=1fd0a226&"
import script from "./PaBusClsList.vue?vue&type=script&lang=js&"
export * from "./PaBusClsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PaBusClsList.vue"
export default component.exports